module.exports = "/assets/78b5859177110135d159bffd3f9e81c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/VW.png
// module id = 1941
// module chunks = 0